import { checkAllScopes } from "@src/components/LimitAccess/check-scopes";
import { useBooleanWebUiScopeMap } from "@src/components/LimitAccess/check-scopes-hooks";

export const useCanCreateAdvancedContentTest = () => {
  const scopeMap = useBooleanWebUiScopeMap();

  return checkAllScopes([
    scopeMap["create_redirect_experiment"],
    scopeMap["create_theme_experiment"],
    scopeMap["create_template_experiment"],
    scopeMap["create_onsite_edits_experiment"],
    scopeMap["create_advanced_content_experiment"],
  ]);
};
